<template>
  <label
    class="wrapper"
    :class="{
      'wrapper--selected': checked,
    }"
  >
    <input
      type="checkbox"
      class="wrapper__select"
      :value="adPost.id"
      :checked="checked"
      @input="onSelect"
    />
    <dl class="wrapper__item item">
      <div class="item__row row-item">
        <dt class="row-item__title">タイトル</dt>
        <dd class="row-item__detail">
          <a :href="postEditUrl" target="_blank">{{ adPost.post.title }}</a>
        </dd>
      </div>
      <div class="item__row row-item">
        <dt class="row-item__title">表示条件</dt>
        <dd class="row-item__detail">
          {{ condition }}
        </dd>
      </div>
    </dl>
  </label>
</template>

<script>
export default {
  name: 'AdPostRuleSetItem',
  props: {
    selected: {
      type: Number,
      default: -1,
    },
    adPost: {
      type: Object,
      required: true,
    },
  },
  computed: {
    postEditUrl() {
      return `/admins/posts/${this.adPost.post.id}/edit`;
    },
    condition() {
      return this.adPost.tags
        .map((tagOrRule) => tagOrRule.map((tag) => tag.name).join(', '))
        .join(' かつ ');
    },
    checked() {
      return this.selected === this.adPost.id;
    },
  },
  methods: {
    onSelect(event) {
      this.$emit(
        'select-ruleset',
        event.target.checked ? this.adPost.id : undefined
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  padding: 8px;

  &--selected {
    background-color: #c9f4c1;
  }

  &__item {
    &:nth-child(n + 2) {
      margin-left: 12px;
    }
  }
}

.item {
  &__row {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}

.row-item {
  display: flex;
  align-items: center;
  font-size: 14px;

  &__title {
    flex: 0 0 auto;
    padding: 0.3em 0.4em;
    border-radius: 2px;
    background-color: #eee;
  }

  &__detail {
    &:nth-child(n + 2) {
      margin-left: 12px;
    }
  }
}
</style>
